import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
var _excluded = ["className", "size", "tip", "wrapperClassName", "style"];
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import React, { Component } from 'react';
import omit from 'rc-util/lib/omit';
import debounce from 'lodash/debounce';
import { ConfigContext } from '../../config/context/config';
import { tuple } from '../_utils/type';
import { classnames } from '../../utils';
import { isValidElement, cloneElement } from '../_utils/reactNode';
import { LoadingStatic } from '@tencent/adp-icons-react';
var SpinSizes = tuple('sm', 'md', 'lg');
var defaultIndicator = null;
function renderIndicator(prefixCls, props) {
  var indicator = props.indicator;
  var dotClassName = "".concat(prefixCls, "-dot");
  if (indicator === null) {
    return null;
  }
  if (isValidElement(indicator)) {
    return cloneElement(indicator, {
      className: classnames(indicator.props.className, dotClassName)
    });
  }
  if (isValidElement(defaultIndicator)) {
    return cloneElement(defaultIndicator, {
      className: classnames(defaultIndicator.props.className, dotClassName)
    });
  }
  return React.createElement("span", {
    className: classnames(dotClassName, "".concat(prefixCls, "-dot-spin"))
  }, React.createElement(LoadingStatic, {
    size: spinSizeMap[props.size || 'md']
  }));
}
function shouldDelay(spinning, delay) {
  return !!spinning && !!delay && !isNaN(Number(delay));
}
var spinSizeMap = {
  lg: 32,
  md: 28,
  sm: 24
};
export var Spin = /*#__PURE__*/function (_Component) {
  _inherits(Spin, _Component);
  var _super = _createSuper(Spin);
  function Spin(props) {
    var _this;
    _classCallCheck(this, Spin);
    _this = _super.call(this, props);
    _this.debouncifyUpdateSpinning = function (props) {
      var _ref = props || _this.props,
        delay = _ref.delay;
      if (delay) {
        _this.cancelExistingSpin();
        _this.updateSpinning = debounce(_this.originalUpdateSpinning, delay);
      }
    };
    _this.updateSpinning = function () {
      var spinning = _this.props.spinning;
      var currentSpinning = _this.state.spinning;
      if (currentSpinning !== spinning) {
        _this.setState({
          spinning: spinning
        });
      }
    };
    _this.renderSpin = function (_ref2) {
      var _classnames;
      var getPrefixCls = _ref2.getPrefixCls;
      var _this$props = _this.props,
        className = _this$props.className,
        size = _this$props.size,
        tip = _this$props.tip,
        wrapperClassName = _this$props.wrapperClassName,
        style = _this$props.style,
        restProps = _objectWithoutProperties(_this$props, _excluded);
      var spinning = _this.state.spinning;
      var prefixCls = getPrefixCls('spin');
      var spinClassName = classnames(prefixCls, (_classnames = {}, _defineProperty(_classnames, "".concat(prefixCls, "-sm"), size === 'sm'), _defineProperty(_classnames, "".concat(prefixCls, "-lg"), size === 'lg'), _defineProperty(_classnames, "".concat(prefixCls, "-spinning"), spinning), _defineProperty(_classnames, "".concat(prefixCls, "-show-text"), !!tip), _classnames), className);
      var divProps = omit(restProps, ['spinning', 'delay', 'indicator']);
      var spinElement = React.createElement("div", _objectSpread(_objectSpread({}, divProps), {}, {
        style: style,
        className: spinClassName
      }), renderIndicator(prefixCls, _this.props), tip ? React.createElement("div", {
        className: "".concat(prefixCls, "-text")
      }, tip) : null);
      if (_this.isNestedPattern()) {
        var containerClassName = classnames("".concat(prefixCls, "-container"), _defineProperty({}, "".concat(prefixCls, "-blur"), spinning));
        return React.createElement("div", _objectSpread(_objectSpread({}, divProps), {}, {
          className: classnames("".concat(prefixCls, "-nested-loading"), wrapperClassName)
        }), spinning && React.createElement("div", {
          key: "loading"
        }, spinElement), React.createElement("div", {
          className: containerClassName,
          key: "container"
        }, _this.props.children));
      }
      return spinElement;
    };
    var spinning = props.spinning,
      delay = props.delay;
    var shouldBeDelayed = shouldDelay(spinning, delay);
    _this.state = {
      spinning: spinning && !shouldBeDelayed
    };
    _this.originalUpdateSpinning = _this.updateSpinning;
    _this.debouncifyUpdateSpinning(props);
    return _this;
  }
  _createClass(Spin, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.updateSpinning();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.debouncifyUpdateSpinning();
      this.updateSpinning();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.cancelExistingSpin();
    }
  }, {
    key: "cancelExistingSpin",
    value: function cancelExistingSpin() {
      var updateSpinning = this.updateSpinning;
      if (updateSpinning && updateSpinning.cancel) {
        updateSpinning.cancel();
      }
    }
  }, {
    key: "isNestedPattern",
    value: function isNestedPattern() {
      return !!(this.props && typeof this.props.children !== 'undefined');
    }
  }, {
    key: "render",
    value: function render() {
      return React.createElement(ConfigContext.Consumer, null, this.renderSpin);
    }
  }], [{
    key: "setDefaultIndicator",
    value: function setDefaultIndicator(indicator) {
      defaultIndicator = indicator;
    }
  }]);
  return Spin;
}(Component);
Spin.defaultProps = {
  spinning: true,
  size: 'md',
  wrapperClassName: ''
};